var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.filteredItems,"value":_vm.value,"label":_vm.label,"loading":_vm.isLoading,"item-text":"name","return-object":"","disabled":_vm.disabled,"rules":_vm.rules},on:{"change":_vm.emitInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }